import React from 'react';
import { BoxProps, Box } from '../../wag-react/next-components/box';
import { theme } from '../../wag-react/themes/base-theme';
import { Container } from '../Container';
import { Typography } from '../Typography';
import { StatesColumnList } from './components/StatesColumnList';
import GetStartedButton from '../GetStartedButton';
export type ColorKeys = keyof typeof theme.colors;
type Props = {
  titleColor?: ColorKeys;
  titleProps?: BoxProps;
  subTitleProps?: BoxProps;
  containerProps?: BoxProps;
};
export const StatesColumnListSection = ({
  titleColor,
  titleProps,
  subTitleProps,
  containerProps
}: Props) => <Container pb={['64px']} pt={['64px']} maxWidth="900px" {...containerProps} data-sentry-element="Container" data-sentry-component="StatesColumnListSection" data-sentry-source-file="index.tsx">
    <Typography color={titleColor || "#222"} m={0} textAlign={['left', 'center']} width={1} fontSize={['26px', '36px']} lineHeight={['34px', '44px']} letterSpacing="0px" fontStyle="normal" fontWeight={700} style={{
    fontFamily: '"Hero New", sans-serif'
  }} {...titleProps} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
      Find a trusted Pet Caregiver near you
    </Typography>
    <Typography color="#474747" fontSize="16px" lineHeight="24px" letterSpacing="0px" fontStyle="normal" fontWeight={400} mb={0} mt={['10px', '18px']} pb={2} textAlign={['left', 'center']} width={1} style={{
    fontFamily: '"Hero New", sans-serif'
  }} {...subTitleProps} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
      Available in 5,300 cities across all 50 states
    </Typography>
    <StatesColumnList mt={['32px', '40px']} data-sentry-element="StatesColumnList" data-sentry-source-file="index.tsx" />
    <Box display="flex" justifyContent="center" mt={4} data-sentry-element="Box" data-sentry-source-file="index.tsx">
      <GetStartedButton data-sentry-element="GetStartedButton" data-sentry-source-file="index.tsx" />
    </Box>
  </Container>;